(() => {
  const selector = '.bfs-priority-menu__details:not(.bfs-shelf-mobile-panel__details)';
  let closeTimer;
  let lastScrollY = window.scrollY;

  // Keep one dropdown open and close it when it no longer belongs to the current interaction.
  const closeMenu = (menu) => {
    if (!menu || !menu.open) return;
    menu.removeAttribute('open');
    menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  };

  const closeAll = (exceptMenu) => {
    document.querySelectorAll(`${selector}[open]`).forEach((menu) => {
      if (menu !== exceptMenu) closeMenu(menu);
    });
  };

  const openMenu = (menu) => {
    if (!menu) return;
    clearTimeout(closeTimer);
    closeAll(menu);
    menu.setAttribute('open', '');
    menu.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  };

  document.addEventListener(
    'toggle',
    (event) => {
      const menu = event.target;

      if (!(menu instanceof HTMLDetailsElement) || !menu.classList.contains('bfs-priority-menu__details')) {
        return;
      }

      menu.querySelector('summary')?.setAttribute('aria-expanded', menu.open ? 'true' : 'false');

      if (menu.open) closeAll(menu);
    },
    true
  );

  document.addEventListener('mouseover', (event) => {
    const menu = event.target.closest?.(selector);
    if (!menu || !window.matchMedia('(min-width: 990px)').matches) return;
    openMenu(menu);
  });

  document.addEventListener('mouseout', (event) => {
    const menu = event.target.closest?.(selector);
    if (!menu || menu.contains(event.relatedTarget)) return;
    // Small delay lets the cursor cross from the trigger into the dropdown.
    closeTimer = window.setTimeout(() => closeMenu(menu), 140);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest?.(selector) || document.querySelector(`${selector}[open]`);
    if (!menu) return;
    closeMenu(menu);
    menu.querySelector('summary')?.focus();
  });

  const setShelfState = (shelfItem, shelfButton, isOpen) => {
    shelfItem.classList.toggle('is-open', isOpen);
    shelfButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    shelfButton.textContent = isOpen ? '-' : '+';
    shelfButton.setAttribute('aria-label', isOpen ? 'Close subcategories' : 'Open subcategories');
  };

  const syncShelfButtons = (root = document) => {
    root.querySelectorAll('.bfs-shelf-menu__plus').forEach((button) => {
      const shelfItem = button.closest('.bfs-shelf-menu__item--has-children');
      setShelfState(shelfItem, button, shelfItem?.classList.contains('is-open'));
    });
  };

  document.addEventListener('click', (event) => {
    const shelfButton = event.target.closest?.('.bfs-shelf-menu__plus');
    if (shelfButton) {
      if (shelfButton.closest('.bfs-shelf-mobile-panel')) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const shelfItem = shelfButton.closest('.bfs-shelf-menu__item--has-children');
      if (!shelfItem) return;

      setShelfState(shelfItem, shelfButton, !shelfItem.classList.contains('is-open'));
      return;
    }

    if (event.target.closest?.('.bfs-priority-menu, .bfs-shelf-mobile-panel')) return;
    closeAll();
  });

  document.addEventListener('focusin', (event) => {
    if (event.target.closest?.('.bfs-priority-menu, .bfs-shelf-mobile-panel')) return;
    closeAll();
  });

  window.addEventListener(
    'scroll',
    () => {
      const delta = Math.abs(window.scrollY - lastScrollY);
      lastScrollY = window.scrollY;
      // Close floating menus once the page has meaningfully moved.
      if (delta > 12) closeAll();
    },
    { passive: true }
  );

  document.querySelectorAll(`${selector} > summary`).forEach((summary) => {
    summary.setAttribute('aria-expanded', summary.parentElement?.open ? 'true' : 'false');
  });

  syncShelfButtons();

  document.addEventListener('DOMContentLoaded', () => syncShelfButtons());
  document.addEventListener('shopify:section:load', (event) => {
    syncShelfButtons(event.target);
  });
})();
